import { all_routes } from "../../../feature-module/router/all_routes";
import { route } from "../../common/selectoption/selectoption";
const routes = all_routes;


export const SidebarDataTest = [
  {
    tittle: 'HRMS',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: 'Dashboard',
        link: routes.dashboard,
        base: 'Dashboard',
        submenu: false,
        showSubRoute: false,
        icon: 'smart-home',
        materialicons: 'start',
        submenuItems: [],
        visibleTo: [1,2],
      },
      {
        label: 'Employees',
        link: "/employees",
        base: 'employees',
        submenu: false,
        showSubRoute: false,
        icon: 'users',
        materialicons: 'people',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Holidays',
        link: "/holidays",
        base: 'holidays',
        submenu: false,
        showSubRoute: false,
        icon: 'plane',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1,2],
      },
      {
        label: 'Banners',
        link: '/banners',
        base: 'banners',
        isActive: (pathname: string) => pathname === '/banners',
        submenu: false,
        showSubRoute: false,
        icon: "photo",              
        materialicons: "perm_media",
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Leave',
        link: "/leave/leave-request",
        isActive: (pathname: string) =>
          pathname.startsWith("/leave/leave-request") ||
          pathname.startsWith("/leave/leave-balance") ||
          pathname.startsWith("/leave-calendar"),
        base: 'leave',
        submenu: false,
        showSubRoute: false,
        icon: 'beach',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1,2],
      },

      {
        label: 'Payroll',
        link: "/payroll",
        isActive: (pathname: string) =>
          pathname.startsWith("/payroll") || pathname.startsWith("/monthlySalary"),
        base: 'payroll',
        submenu: false,
        showSubRoute: false,
        icon: 'cash',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1, 2],
      },

    //    {
    //     label: 'Payroll',
    //     link: "/monthlySalary",
    //     base: 'monthlySalary',
    //     submenu: false,
    //     showSubRoute: false,
    //     icon: 'cash',
    //     materialicons: 'confirmation_number',
    //     submenuItems: [],
    //     visibleTo: [1,2],
    //   },
      {
        label: 'Inventory',
        link: '/inventory',
        base: 'inventory',
        submenu: false,
        showSubRoute: false,
        icon: 'device-laptop',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Attendance',
        link: '/attendance-view',
        base: 'attendance',
        submenu: false,
        showSubRoute: false,
        icon: 'calendar-user',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1,2],
      },
      {
        label: 'Resumes',
        link: '/resumes',
        base: 'resumes',
        submenu: false,
        showSubRoute: false,
        icon: 'id-badge-2',          // <- Tabler-style icon that fits "resume/CV"
        materialicons: 'assignment_ind',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Job Openings',
        link: '/job-openings',
        base: 'jobOpening',
        submenu: false,
        showSubRoute: false,
        icon: 'briefcase',          
        materialicons: 'work_outline',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Interviews',
        link: '/interviews',
        base: 'interviews',
        submenu: false,
        showSubRoute: false,
        icon: 'user-check',          
        materialicons: 'record_voice_over',
        submenuItems: [],
        visibleTo: [1,2],
        requiresInterviewCheck: true,
      },
       
    ],
  },
  {
    tittle: 'Settings',
    icon: 'file',
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: 'Designations',
        link: routes.designation,
        base: 'designation',
        submenu: false,
        showSubRoute: false,
        icon: 'user-code',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Document Headers',
        link: routes.documentHeader,
        base: 'documentHeader',
        submenu: false,
        showSubRoute: false,
        icon: 'text-caption',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Pay Headers',
        link: routes.payHeader,
        base: 'payHeader',
        submenu: false,
        showSubRoute: false,
        icon: 'cash-banknote',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Vendors',
        link: '/vendors',
        base: 'vendor',
        submenu: false,
        showSubRoute: false,
        icon: 'building-warehouse',
        materialicons: 'confirmation_number',
        submenuItems: [],
        visibleTo: [1],
      },
       {
        label: 'Policy Documents',
        link: '/policy-document',
        base: 'policyDocument',
        isActive: (pathname: string) => pathname === '/policy-document',
        submenu: false,
        showSubRoute: false,
        icon: 'file-text',
        materialicons: 'policy',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Induction Checklist',
        link: '/induction-checklist',
        base: 'inductionChecklist',
        isActive: (pathname: string) => pathname === '/induction-checklist',
        submenu: false,
        showSubRoute: false,
        icon: 'clipboard-list',
        materialicons: 'assignment',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'Access Revoke',
        link: '/access-revoke-checklist',
        base: 'accessRevokeChecklist',
        isActive: (pathname: string) => pathname === '/access-revoke-checklist',
        submenu: false,
        showSubRoute: false,
        icon: 'door-exit',
        materialicons: 'logout',
        submenuItems: [],
        visibleTo: [1],
      },
      {
        label: 'App Store Settings',
        link: routes.appStoreSettings,
        base: 'appStoreSettings',
        isActive: (pathname: string) => pathname === routes.appStoreSettings,
        submenu: false,
        showSubRoute: false,
        icon: 'apps',
        materialicons: 'app_settings_alt',
        submenuItems: [],
        visibleTo: [1],
      },
    ],
  },
  // {
  //   tittle: 'Administration',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: 'Assets',
  //       base: 'assets',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'cash',
  //       submenuItems: [
  //         {
  //           label: 'Assets',
  //           link: routes.assetList,
  //           base: 'asset-list',
  //         },
  //         {
  //           label: 'Asset Categories',
  //           link: routes.assetCategories,
  //           base: 'asset-categories',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Help & Supports',
  //       base: 'supports',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'headset',
  //       submenuItems: [
  //         {
  //           label: 'Knowledge Base',
  //           link: routes.knowledgebase,
  //           base: 'knowledgebase',
  //           base2: 'knowledgebase-view',
  //           base3: 'knowledgebase-details',
  //         },
  //         {
  //           label: 'Activities',
  //           link: routes.activity,
  //           base: 'activities',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'User Management',
  //       base: 'user-management',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'user-star',
  //       submenuItems: [
  //         {
  //           label: 'Users',
  //           link: routes.users,
  //           base: 'users',
  //         },
  //         {
  //           label: 'Roles & Permissions',
  //           link: routes.rolePermission,
  //           base: 'roles-permissions',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Reports',
  //       base: 'reports',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'user-star',
  //       submenuItems: [
  //         {
  //           label: 'Expense Report',
  //           link: routes.expensesreport,
  //           base: 'expenses-report',
  //         },
  //         {
  //           label: 'Invoice Report',
  //           link: routes.invoicereport,
  //           base: 'invoice-report',
  //         },
  //         {
  //           label: 'Payment Report',
  //           link: routes.paymentreport,
  //           base: 'payment-report',
  //         },
  //         {
  //           label: 'Project Report',
  //           link: routes.projectreport,
  //           base: 'project-report',
  //         },
  //         {
  //           label: 'Task Report',
  //           link: routes.taskreport,
  //           base: 'task-report',
  //         },
  //         {
  //           label: 'User Report',
  //           link: routes.userreport,
  //           base: 'user-report',
  //         },
  //         {
  //           label: 'Employee Report',
  //           link: routes.employeereport,
  //           base: 'employee-report',
  //         },
  //         {
  //           label: 'Payslip Report',
  //           link: routes.payslipreport,
  //           base: 'payslip-report',
  //         },
  //         {
  //           label: 'Attendance Report',
  //           link: routes.attendancereport,
  //           base: 'attendance-report',
  //         },
  //         {
  //           label: 'Leave Report',
  //           link: routes.leavereport,
  //           base: 'leave-report',
  //         },
  //         {
  //           label: 'Daily Report',
  //           link: routes.dailyreport,
  //           base: 'daily-report',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Settings',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'settings',
  //       base: 'settings',
  //       submenuItems: [
  //         {
  //           label: 'General Settings',
  //           customSubmenuTwo: true,
  //           base: 'general-settings',
  //           submenuItems: [
  //             {
  //               label: 'Profile',
  //               link: routes.profilesettings,
  //               base: 'profile-settings',
  //               submenu: false,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: 'Security',
  //               link: routes.securitysettings,
  //               base: 'security-settings',
  //               submenu: false,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: 'Notifications',
  //               link: routes.notificationssettings,
  //               base: 'notification-settings',
  //               submenu: false,
  //               showSubRoute: false,
  //             },
  //             {
  //               label: 'Connected Apps',
  //               link: routes.connectedApps,
  //               base: 'connected-apps',
  //               submenu: false,
  //               showSubRoute: false,
  //             },
  //           ],
  //         },
  //         {
  //           label: 'Website Settings',
  //           customSubmenuTwo: true,
  //           base: 'website-settings',
  //           submenuItems: [
  //             {
  //               label: 'Business Settings',
  //               link: routes.bussinessSettings,
  //               base: 'bussiness-settings',
  //             },
  //             {
  //               label: 'SEO Settings',
  //               link: routes.seoSettings,
  //               base: 'seo-settings',
  //             },
  //             {
  //               label: 'Localization',
  //               link: routes.localizationSettings,
  //               base: 'localization-settings',
  //             },
  //             {
  //               label: 'Prefixes',
  //               link: routes.prefixes,
  //               base: 'prefixes',
  //             },
  //             {
  //               label: 'Preferences',
  //               link: routes.preference,
  //               base: 'preferences',
  //             },
  //             {
  //               label: 'Appearance',
  //               link: routes.appearance,
  //               base: 'appearance',
  //             },
  //             {
  //               label: 'Language',
  //               link: routes.language,
  //               base: 'language',
  //               base2: 'add-language',
  //             },
  //             {
  //               label: 'Authentication',
  //               link: routes.authenticationSettings,
  //               base: 'authentication-settings',
  //             },
  //             {
  //               label: 'AI Settings',
  //               link: routes.aiSettings,
  //               base: 'ai-settings',
  //             },
  //           ],
  //         },
  //         {
  //           label: 'App Settings',
  //           customSubmenuTwo: true,
  //           base: 'app-settings',
  //           submenuItems: [
  //             {
  //               label: 'Salary Settings',
  //               link: routes.salarySettings,
  //               base: 'salary-settings',
  //             },
  //             {
  //               label: 'Approval Settings',
  //               link: routes.approvalSettings,
  //               base: 'approval-settings',
  //             },
  //             {
  //               label: 'Invoice Settings',
  //               link: routes.invoiceSettings,
  //               base: 'invoice-settings',
  //             },
  //             {
  //               label: 'Leave Type',
  //               link: routes.leaveType,
  //               base: 'leave-type',
  //             },
  //             {
  //               label: 'Custom Fields',
  //               link: routes.customFields,
  //               base: 'custom-fields',
  //             },
  //           ],
  //         },
  //         {
  //           label: 'System Settings',
  //           customSubmenuTwo: true,
  //           base: 'system-settings',
  //           submenuItems: [
  //             {
  //               label: 'Email Settings',
  //               link: routes.emailSettings,
  //               base: 'email-settings',
  //             },
  //             {
  //               label: 'Email Templates',
  //               link: routes.emailTemplates,
  //               base: 'email-template',
  //             },
  //             {
  //               label: 'SMS Settings',
  //               link: routes.smsSettings,
  //               base: 'sms-settings',
  //             },
  //             {
  //               label: 'SMS Templates',
  //               link: routes.smsTemplate,
  //               base: 'sms-template',
  //             },
  //             {
  //               label: 'OTP',
  //               link: routes.otpSettings,
  //               base: 'otp-settings',
  //             },
  //             {
  //               label: 'GDPR Cookies',
  //               link: routes.gdprCookies,
  //               base: 'gdpr',
  //             },
  //             {
  //               label: 'Maintenance Mode',
  //               link: routes.maintenanceMode,
  //               base: 'maintenance-mode',
  //             },
  //           ],
  //         },
  //         {
  //           label: 'Financial Settings',
  //           customSubmenuTwo: true,
  //           base: 'financial-settings',
  //           submenuItems: [
  //             {
  //               label: 'Payment Gateways',
  //               link: routes.paymentGateways,
  //               base: 'payment-gateways',
  //             },
  //             {
  //               label: 'Tax Rate',
  //               link: routes.taxRates,
  //               base: 'tax-rates',
  //             },
  //             {
  //               label: 'Currencies',
  //               link: routes.currencies,
  //               base: 'currencies',
  //             },
  //           ],
  //         },
  //         {
  //           label: 'Other Settings',
  //           customSubmenuTwo: true,
  //           base: 'other-settings',
  //           submenuItems: [
  //             {
  //               label: 'Custom CSS',
  //               link: routes.customCss,
  //               base: 'custom-css',
  //             },
  //             {
  //               label: 'Custom JS',
  //               link: routes.customJs,
  //               base: 'custom-js',
  //             },
  //             {
  //               label: 'Cronjob',
  //               link: routes.cronjob,
  //               base: 'cronjob',
  //             },
  //             {
  //               label: 'Storage',
  //               link: routes.storage,
  //               base: 'storage-settings',
  //             },
  //             {
  //               label: 'Ban IP Address',
  //               link: routes.banIpAddress,
  //               base: 'ban-ip-address',
  //             },
  //             {
  //               label: 'Backup',
  //               link: routes.backup,
  //               base: 'backup',
  //             },
  //             {
  //               label: 'Clear Cache',
  //               link: routes.clearcache,
  //               base: 'clear-cache',
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   tittle: 'Content',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: 'Pages',
  //       link: routes.pages,
  //       base: 'pages',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'box-multiple',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Blogs',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'brand-blogger',
  //       base: 'blogs',
  //       submenuItems: [
  //         {
  //           label: 'All Blogs',
  //           link: routes.blogs,
  //           base2: 'All Blogs',
  //         },
  //         {
  //           label: 'Categories',
  //           link: routes.blogCategories,
  //           base: '/blog-categories',
  //         },
  //         {
  //           label: 'Comments',
  //           link: routes.blogComments,
  //           base: '/blog-comments',
  //         },
  //         {
  //           label: 'Blog Tags',
  //           link: routes.blogTags,
  //           base: '/blog-tags',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Locations',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'map-pin-check',
  //       base: 'location',
  //       submenuItems: [
  //         {
  //           label: 'Countries',
  //           link: routes.countries,
  //           base: 'countries',
  //         },
  //         {
  //           label: 'States',
  //           link: routes.states,
  //           base: 'states',
  //         },
  //         {
  //           label: 'Cities',
  //           link: routes.cities,
  //           base: 'cities',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Testimonials',
  //       link: routes.testimonials,
  //       base: 'testimonials',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'message-2',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'FAQ’S',
  //       link: routes.faq,
  //       base: 'faq',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'question-mark',
  //       submenuItems: [],
  //     },
  //   ],
  // },
  // {
  //   tittle: 'Pages',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: 'Starter',
  //       link: routes.starter,
  //       base: 'starter',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'layout-sidebar',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Profile',
  //       link: routes.profile,
  //       base: 'profile',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'user-circle',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Gallery',
  //       link: routes.gallery,
  //       base: 'gallery',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'photo',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Search Results',
  //       link: routes.searchresult,
  //       base: 'search-result',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'list-search',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Timeline',
  //       link: routes.timeline,
  //       base: 'timeline',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'timeline',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Pricing',
  //       link: routes.pricing,
  //       base: 'pricing',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'file-dollar',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Coming Soon',
  //       link: routes.comingSoon,
  //       base: 'coming-soon',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'progress-bolt',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Under Maintenance',
  //       link: routes.underMaintenance,
  //       base: 'under-maintenance',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'alert-octagon',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Under Construction',
  //       link: routes.underConstruction,
  //       base: 'under-construction',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'barrier-block',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'API Keys',
  //       link: routes.apikey,
  //       base: 'api-keys',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'api',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Privacy Policy',
  //       link: routes.privacyPolicy,
  //       base: 'privacy-policy',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'file-description',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Terms & Conditions',
  //       link: routes.termscondition,
  //       base: 'terms-condition',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'file-check',
  //       submenuItems: [],
  //     },
  //   ],
  // },
  // {
  //   tittle: 'Authentication',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
      // {
      //   label: 'Login',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'login',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.login,
      //     }
      //   ],
      // },
      // {
      //   label: 'Register',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'forms',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.register,
      //     },
      //     {
      //       label: 'Illustration',
      //       link: routes.register2,
      //     },
      //     {
      //       label: 'Basic',
      //       link: routes.register3,
      //     },
      //   ],
      // },
      // {
      //   label: 'Forgot Password',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'help-triangle',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.forgotPassword,
      //     },
      //   ],
      // },
      // {
      //   label: 'Reset Password',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'restore',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.resetPassword,
      //     },
      //     {
      //       label: 'Illustration',
      //       link: routes.resetPassword2,
      //     },
      //     {
      //       label: 'Basic',
      //       link: routes.resetPassword3,
      //     },
      //   ],
      // },
      // {
      //   label: 'Email Verification',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'mail-exclamation',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.emailVerification,
      //     },
      //     {
      //       label: 'Illustration',
      //       link: routes.emailVerification2,
      //     },
      //     {
      //       label: 'Basic',
      //       link: routes.emailVerification3,
      //     },
      //   ],
      // },
      // {
      //   label: '2 Step Verification',
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: 'password',
      //   submenuItems: [
      //     {
      //       label: 'Cover',
      //       link: routes.twoStepVerification,
      //     },
      //     {
      //       label: 'Illustration',
      //       link: routes.twoStepVerification2,
      //     },
      //     {
      //       label: 'Basic',
      //       link: routes.twoStepVerification3,
      //     },
      //   ],
      // },
      // {
      //   label: 'Lock Screen',
      //   link: routes.lockScreen,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'lock-square',
      //   submenuItems: [],
      // },
      // {
      //   label: '404 Error',
      //   link: routes.error404,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'error-404',
      //   submenuItems: [],
      // },
      // {
      //   label: '500 Error',
      //   link: routes.error500,
      //   submenu: false,
      //   showSubRoute: false,
      //   icon: 'server',
      //   submenuItems: [],
      // },
  //   ],
  // },
  // {
  //   tittle: 'UI Interface',
  //   icon: 'file',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: 'Base UI',
  //       link: 'index',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'hierarchy-2',
  //       base: 'base-ui',
  //       materialicons: 'description',
  //       submenuItems: [
  //         {
  //           label: 'Alerts',
  //           link: routes.alert,
  //           base: 'ui-alerts',
  //         },
  //         {
  //           label: 'Accordions',
  //           link: routes.accordion,
  //           base: 'ui-accordion',
  //         },
  //         { label: 'Avatar', link: routes.avatar, base: 'ui-avatar' },
  //         { label: 'Badges', link: routes.badges, base: 'ui-badges' },
  //         { label: 'Borders', link: routes.border, base: 'ui-borders' },
  //         {
  //           label: 'Buttons',
  //           link: routes.button,
  //           base: 'ui-buttons',
  //         },
  //         {
  //           label: 'Button Group',
  //           link: routes.buttonGroup,
  //           base: 'ui-buttons-group',
  //         },
  //         {
  //           label: 'Breadcrumb',
  //           link: routes.breadcrums,
  //           base: 'ui-breadcrumb',
  //         },
  //         { label: 'Cards', link: routes.cards, base: 'ui-cards' },
  //         {
  //           label: 'Carousel',
  //           link: routes.carousel,
  //           base: 'ui-carousel',
  //         },
  //         {
  //           label: 'Colors',
  //           link: routes.colors,
  //           base: 'ui-colors',
  //         },
  //         {
  //           label: 'Dropdowns',
  //           link: routes.dropdowns,
  //           base: 'ui-dropdowns',
  //         },
  //         { label: 'Grid', link: routes.grid, base: 'ui-grid' },
  //         { label: 'Images', link: routes.images, base: 'ui-images' },
  //         {
  //           label: 'Lightbox',
  //           link: routes.lightbox,
  //           base: 'ui-lightbox',
  //         },
  //         { label: 'Media', link: routes.media, base: 'ui-media' },
  //         { label: 'Modals', link: routes.modals, base: 'ui-modals' },
  //         {
  //           label: 'Offcanvas',
  //           link: routes.offcanvas,
  //           base: 'ui-offcanvas',
  //         },
  //         {
  //           label: 'Pagination',
  //           link: routes.pagination,
  //           base: 'ui-pagination',
  //         },

  //         {
  //           label: 'Progress Bars',
  //           link: routes.progress,
  //           base: 'ui-progress',
  //         },
  //         {
  //           label: 'Placeholders',
  //           link: routes.placeholder,
  //           base: 'ui-placeholders',
  //         },

  //         {
  //           label: 'Spinner',
  //           link: routes.spinner,
  //           base: 'ui-spinner',
  //         },
  //         {
  //           label: 'Range Slider',
  //           link: routes.rangeSlider,
  //           base: 'ui-rangeslider',
  //         },

  //         { label: 'Toasts', link: routes.toasts, base: 'ui-toasts' },
  //         {
  //           label: 'Tooltip',
  //           link: routes.tooltip,
  //           base: 'ui-tooltips',
  //         },
  //         {
  //           label: 'Typography',
  //           link: routes.typography,
  //           base: 'ui-typography',
  //         },
  //         { label: 'Videos', link: routes.video, base: 'ui-video' },
  //         { label: 'Sortable', link: routes.sortable, base: 'ui-sortable' },
  //         { label: 'SwiperJs', link: routes.swiperjs, base: 'ui-swiperjs' },
  //       ],
  //     },
  //     {
  //       label: 'Advanced Ui',
  //       submenu: true,
  //       showSubRoute: false,
  //       base: 'advancedUi',
  //       icon: 'hierarchy-3',
  //       materialicons: 'sync_alt',
  //       submenuItems: [
  //         { label: 'Ribbon', link: routes.ribbon, base: 'ui-ribbon' },
  //         {
  //           label: 'Clipboard',
  //           link: routes.clipboard,
  //           base: 'ui-clipboard',
  //         },
  //         {
  //           label: 'Drag & Drop',
  //           link: routes.dragandDrop,
  //           base: 'ui-drag-drop',
  //         },
  //         {
  //           label: 'Rating',
  //           link: routes.rating,
  //           base: 'ui-rating',
  //         },
  //         {
  //           label: 'Text Editor',
  //           link: routes.textEditor,
  //           base: 'ui-text-editor',
  //         },
  //         {
  //           label: 'Counter',
  //           link: routes.counter,
  //           base: 'ui-counter',
  //         },
  //         {
  //           label: 'Scrollbar',
  //           link: routes.scrollBar,
  //           base: 'ui-scrollbar',
  //         },
  //         {
  //           label: 'Timeline',
  //           link: routes.timeLine,
  //           base: 'ui-timeline',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Charts',
  //       submenu: true,
  //       showSubRoute: false,
  //       base: 'charts',
  //       icon: 'chart-line',
  //       materialicons: 'library_add_check',
  //       submenuItems: [
  //         {
  //           label: 'Apex Charts',
  //           link: routes.apexChart,
  //           base: 'apex-charts',
  //         },
  //         {
  //           label: 'Prime Charts',
  //           link: routes.primeChart,
  //           base: 'prime-charts',
  //         },
  //         {
  //           label: 'Chart JS',
  //           link: routes.chartJs,
  //           base: 'chart-js',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Icons',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'icons',
  //       base: 'icon',
  //       materialicons: 'people',
  //       submenuItems: [
  //         {
  //           label: 'Fontawesome Icons',
  //           link: routes.fontawesome,
  //           base: 'icon-fontawesome',
  //         },
  //         {
  //           label: 'Bootstrap Icons',
  //           link: routes.bootstrapIcons,
  //           base: 'icon-bootstrap',
  //         },
  //         {
  //           label: 'Remix Icons',
  //           link: routes.RemixIcons,
  //           base: 'icon-remix',
  //         },
  //         {
  //           label: 'Feather Icons',
  //           link: routes.featherIcons,
  //           base: 'icon-feather',
  //         },
  //         {
  //           label: 'Ionic Icons',
  //           link: routes.iconicIcon,
  //           base: 'icon-ionic',
  //         },
  //         {
  //           label: 'Material Icons',
  //           link: routes.materialIcon,
  //           base: 'icon-material',
  //         },
  //         { label: 'pe7 Icons', link: routes.pe7icon, base: 'icon-pe7' },
  //         {
  //           label: 'Simpleline Icons',
  //           link: routes.simpleLineIcon,
  //           base: 'icon-simple-line',
  //         },
  //         {
  //           label: 'Themify Icons',
  //           link: routes.themifyIcon,
  //           base: 'icon-themify',
  //         },
  //         {
  //           label: 'Weather Icons',
  //           link: routes.weatherIcon,
  //           base: 'icon-weather',
  //         },
  //         {
  //           label: 'Typicon Icons',
  //           link: routes.typicon,
  //           base: 'icon-typicon',
  //         },
  //         { label: 'Flag Icons', link: routes.FlagIcons, base: 'icon-flag' },
  //       ],
  //     },
  //     {
  //       label: 'Forms',
  //       icon: 'input-search',
  //       base: 'forms',
  //       submenu: true,
  //       showSubRoute: false,
  //       materialicons: 'view_day',
  //       submenuItems: [
  //         {
  //           label: 'Form Elements',
  //           base: 'form-elements',
  //           customSubmenuTwo: true,
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //               label: 'Basic Inputs',
  //               link: routes.basicInput,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-basic-inputs',
  //             },
  //             {
  //               label: 'Checkbox & Radios',
  //               link: routes.checkboxandRadion,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-checkbox-radios',

  //             },
  //             {
  //               label: 'Input Groups',
  //               link: routes.inputGroup,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-input-groups',

  //             },
  //             {
  //               label: 'Grid & Gutters',
  //               link: routes.gridandGutters,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-grid-gutters',
  //             },
  //             {
  //               label: 'Form Select',
  //               link: routes.formSelect,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-select',

  //             },
  //             {
  //               label: 'Input Masks',
  //               link: routes.formMask,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-mask',
  //             },
  //             {
  //               label: 'File Uploads',
  //               link: routes.fileUpload,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-fileupload',
  //             },
  //           ],
  //         },
  //         {
  //           label: 'Layouts',
  //           customSubmenuTwo: true,
  //           base: 'layouts',
  //           submenu: true,
  //           showSubRoute: false,
  //           submenuItems: [
  //             {
  //               label: 'Horizontal Form',
  //               link: routes.horizontalForm,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-horizontal'
  //             },
  //             {
  //               label: 'Vertical Form',
  //               link: routes.verticalForm,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-vertical',
  //             },
  //             {
  //               label: 'Floating Labels',
  //               link: routes.floatingLable,
  //               submenu: false,
  //               showSubRoute: false,
  //               base: 'form-floating-labels',

  //             },
  //           ],
  //         },
  //         {
  //           label: 'Form Validation',
  //           link: routes.formValidation,
  //           submenu: false,
  //           showSubRoute: false,
  //           customSubmenuTwo: false,
  //           base: 'form-validation',
  //         },
  //         {
  //           label: 'Form Wizard',
  //           link: routes.formWizard,
  //           submenu: false,
  //           showSubRoute: false,
  //           customSubmenuTwo: false,
  //           base: 'form-wizard',
  //         },
  //         {
  //           label: 'Form Picker',
  //           link: routes.formPicker,
  //           submenu: false,
  //           showSubRoute: false,
  //           customSubmenuTwo: false,
  //           base: 'form-picker',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Tables',
  //       link: 'tables',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'table',
  //       base: 'tables',
  //       materialicons: 'table_rows',
  //       submenuItems: [
  //         {
  //           label: 'Basic Tables',
  //           link: routes.tablesBasic,
  //           base: 'tables-basic',
  //         },
  //         {
  //           label: 'Data Tables',
  //           link: routes.dataTables,
  //           base: 'data-basic',
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Maps',
  //       submenu: true,
  //       showSubRoute: false,
  //       icon: 'table-plus',
  //       base: 'maps',
  //       materialicons: 'people',
  //       submenuItems: [
  //         {
  //           label: 'Leaflets',
  //           link: routes.mapLeaflet,
  //           base: 'leaflets',
  //         },

  //       ],
  //     },
  //   ],
  // },
  // {
  //   tittle: 'Extras',
  //   icon: 'file',
  //   showAsTab: false,
  //   separateRoute: false,
  //   submenuItems: [
  //     {
  //       label: 'Documentation',
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'file-text',
  //       base: '1',
  //       materialicons: 'description',
  //       submenuItems: [],
  //     },
  //     {
  //       label: 'Change Log',
  //       changeLogVersion: true,
  //       submenu: false,
  //       showSubRoute: false,
  //       icon: 'exchange',
  //       base: '1',
  //       materialicons: 'sync_alt',
  //       submenuItems: [],
  //     },
  //   ],
  // },
];
